import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const BlankLayout = ({ children }) => {
  const navigate = useNavigate();
  useEffect(() => {
    const checkUser = () => {
      const userStr = localStorage.getItem("user");
      const user = userStr ? JSON.parse(userStr) : null;
      const currentPath = window.location.pathname;
      
      // Allow access to all pages regardless of profile completion
      // Business details will be checked only during subscription purchase
      if (user && currentPath !== "/login" && currentPath !== "/signup" && currentPath !== "/forget-password") {
        // No redirect needed - user can access all pages
      }
    };

    checkUser();
  }, [navigate]);
  return <main>{children}</main>;
};

export default BlankLayout;
